import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { LockKeyhole } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PasswordInput } from "@/components/account/LoginForm";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message);
      navigate("/cuenta", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="bg-slate-50 min-h-screen" data-testid="reset-password-page">
      <Navbar />
      <main className="pt-32 pb-20 max-w-md mx-auto px-4 sm:px-6">
        <div className="bg-white border border-slate-200 rounded-3xl p-8 sm:p-10 shadow-xl shadow-slate-900/5 fade-up">
          <span className="inline-flex items-center justify-center h-12 w-12 rounded-2xl bg-cyan-50 text-cyan-600 mb-5">
            <LockKeyhole className="h-6 w-6" />
          </span>
          <h1 className="text-2xl font-heading font-bold text-slate-900">Crea una nueva contraseña</h1>
          {!token ? (
            <p className="text-sm text-red-600 mt-3" data-testid="reset-password-missing-token">
              El enlace no es válido. <Link to="/cuenta/recuperar" className="underline">Solicita uno nuevo</Link>.
            </p>
          ) : (
            <form onSubmit={submit} className="space-y-4 mt-6" data-testid="reset-password-form">
              <div className="space-y-2">
                <Label htmlFor="rp-password">Nueva contraseña <span className="text-slate-400 font-normal">(mínimo 8 caracteres)</span></Label>
                <PasswordInput id="rp-password" testId="reset-password-input" value={password}
                  onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="rp-confirm">Repite la contraseña</Label>
                <PasswordInput id="rp-confirm" testId="reset-password-confirm-input" value={confirm}
                  onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" />
              </div>
              <Button type="submit" disabled={loading} data-testid="reset-password-submit-btn"
                className="w-full h-11 rounded-full bg-cyan-500 hover:bg-cyan-600">
                {loading ? "Guardando..." : "Guardar contraseña"}
              </Button>
            </form>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
